module.exports = __webpack_public_path__ + "static/media/policyCard.b0010a01.svg";